import React from 'react'
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import {
  Badge,
  Button,
  Box,
  CircularProgress,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  TableSortLabel,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core"
import {
  actionGetInvitatios,
  actionDeleteTicket
} from "../../actions/EventActions";
import { Autocomplete } from "@material-ui/lab"
import { withTheme } from "@material-ui/core/styles"
import DeleteIcon from "@material-ui/icons/Delete";
import ColorIcon from "@material-ui/icons/FiberManualRecord";
import SearchIcon from "@material-ui/icons/Search";
import Util, { SUCCESS, ERROR } from "../../common/Util"
import ChipRedimidor from "../../components/ChipRedimidor/ChipRedimidor"
import { ORIGIN } from "../../common/Constants";

let _handleSubmitFail;

class InvitationsDialog extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 0,
      rowPerPage: 5,
      count: 0,
      tickets: [],
      search: "",
      ticketForDelete: false,
      orderBy: "tktInviteDate",
      orderDesc: true,
      loading: false
    }
    this.onConfirmDeleteTicket = this.onConfirmDeleteTicket.bind(this)
    this.renderTableHeader = this.renderTableHeader.bind(this)
    this.renderTableBody = this.renderTableBody.bind(this)
    this.onChangePage = this.onChangePage.bind(this)
    this.onChangeRowsPerPage = this.onChangeRowsPerPage.bind(this)
    this.getTicketsError = this.getTicketsError.bind(this)
    this.onSortByField = this.onSortByField.bind(this)
    this.onSearch = this.onSearch.bind(this)
    this.getDeleteTicketSuccess = this.getDeleteTicketSuccess.bind(this)
    this.getDeleteTicketError = this.getDeleteTicketError.bind(this)
    _handleSubmitFail = this.handleSubmitFail.bind(this)

  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({
        page: 0,
        rowPerPage: 5,
        count: 0,
        tickets: [],
        search: "",
        ticketForDelete: false,
        orderBy: "tktInviteDate",
        orderDesc: true,
        loading: false
      }, this.onChangePage)
    }
  }

  handleSubmitFail(error) {
    console.log("ERROR EN EL SUBMIT", error)
  }

  onSearch(evt) {
    this.setState(
      { search: evt.target.value, errorEmail: "" }
    );
  }

  getTicketsError(e) {
    console.log("ERROR AL LISTAR TICKETS DE USUARIOS NO REGISTRADOS", e);
    this.setState({ loading: false })
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al listar los tickets de usuarios no registrados.");
  }

  onChangePage(dta, newPage = 0) {
    console.log("this.props.event.id", this.props.event && this.props.event.id);
    this.setState({ loading: true })
    const from = newPage * this.state.rowPerPage
    this.props.actionGetInvitatios(
      { evtId: this.props.event.id, search: this.state.search },
      { field: this.state.orderBy, desc: this.state.orderDesc },
      { from: from, to: from + this.state.rowPerPage },
      () => {
        this.setState({
          page: newPage,
          loading: false
        });
      },
      this.getTicketsError
    );
  }

  onChangeRowsPerPage(evt) {
    this.setState(
      {
        rowPerPage: evt.target.value,
      },
      this.onChangePage
    );
  }

  onDeleteTicket(ticket) {
    this.setState({ ticketForDelete: ticket });
  }


  getDeleteTicketSuccess() {
    const event = this.props.event;
    this.onChangePage(null, this.state.page);
  }

  getDeleteTicketError(e) {
    console.log("ERROR GET DELETE TICKET", e);
    if (!(e && e.status && e.status == 401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar la invitación.");
  }

  onConfirmDeleteTicket() {
    const { id, proDNI, tktState } = this.state.ticketForDelete;
    this.props.actionDeleteTicket(
      id,
      proDNI,
      tktState,
      this.getDeleteTicketSuccess,
      this.getDeleteTicketError
    );
    this.setState({ ticketForDelete: false });
  }

  onSortByField(field) {
    if (field == this.state.orderBy) {
      this.setState({ orderDesc: !this.state.orderDesc }, this.onChangePage);
    } else {
      this.setState({ orderBy: field }, this.onChangePage);
    }
  }

  renderTableHeader() {
    const { theme } = this.props;

    const headers = [
      { id: "tktDisplayName", label: "Nombre", hasFilter: true },
      { id: "tktCategory", label: "Categoría" },
      { id: "proDNI", label: "DNI Invitado" },
      { id: "tktPrice", label: "Precio" },
      { id: "tktInviteDate", label: "Fecha de compra", hasFilter: true },
      { id: "tktState", label: "Status", hasFilter: false },
      { id: "createEmail", label: "Creado por", hasFilter: false },
    ];
    return (
      <TableRow>
        {headers.map((label) => {
          return (
            <TableCell>
              {label.hasFilter ? (
                <TableSortLabel
                  active={this.state.orderBy === label.id}
                  direction={
                    this.state.orderBy === label.id && this.state.orderDesc
                      ? "desc"
                      : "asc"
                  }
                  onClick={() => this.onSortByField(label.id)}
                  hideSortIcon={false}
                >
                  {label.label}
                </TableSortLabel>
              ) : (
                label.label
              )}
            </TableCell>
          );
        })}
        <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
      </TableRow>
    );
  }

  renderTableBody() {
    const { theme, invitationsList } = this.props;
    let tickets = invitationsList.items;
    if (this.state.loading) {
      return <TableRow>
        <TableCell colSpan={5}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <CircularProgress style={{ margin: 30, alignSelf: "center" }} />
            <Typography>Cargando registros</Typography>
          </Box>
        </TableCell>
      </TableRow>
    }
    if (!tickets || tickets.length == 0) {
      return <Box style={theme.table.empty}>No se encontraron registros</Box>;
    }
    return tickets.map((item, index) => {
      console.log("******* ITEM", item);
      let isActive = item.tktState;
      let stateLabel;
      switch (item.tktState) {
        // case "pendingUse":
        //   stateLabel = "Pendiente";
        //   break;
        // case "already_used":
        //   stateLabel = "Utilizado";
        //   break;
        case "pendingCreate":
          stateLabel = "Sin Generar";
          break;
        case "pendingTransfer":
          stateLabel = "Provisorio";
          break;
        default:
          stateLabel = "";
      }
      let itemCountTooltip = null;
      if (item.ticketCount) {
        itemCountTooltip =
          item.ticketCount > 1
            ? `${item.ticketCount} ${item.tktState == "pendingCreate" ? "tickets por generar" : "tickets provisorios"}`
            : `${item.ticketCount} ${item.tktState == "pendingCreate" ? "ticket por generar" : "ticket provisorio"}`;
      }
      let origin = {};
      switch (item.tktOrigin) {
        case ORIGIN.standard:
          origin.label = item.rrppName ? "R" : "";
          origin.tooltip = item.rrppName ? "Referenciada" : "";
          origin.color = item.rrppName ? "#777777" : "transparent";
          break;
        case ORIGIN.rrppSell:
          origin.label = "D";
          origin.tooltip = "Venta Directa";
          origin.color = "black";
          break;
        case ORIGIN.producer:
          origin.label = "D";
          origin.tooltip = "Venta Directa";
          origin.color = "black";
          break;
        case ORIGIN.producerBO:
          origin.label = "D";
          origin.tooltip = "Venta Directa";
          origin.color = "black";
          break;
        case ORIGIN.gift:
          origin.label = "I";
          origin.tooltip = "Invitación";
          origin.color = "orange";
          break;
        case ORIGIN.loyaly:
          origin.label = "C";
          origin.tooltip = "Canje";
          origin.color = "#B0A80D";
          break;
        default:
          origin.label = "";
          origin.tooltip = "";
          origin.color = "transparent";
          break;
      }
      return (
        <TableRow
          style={index % 2 == 0 ? theme.table.row : theme.table.rowColor}
        >
          <TableCell style={{ paddingTop: 12 }}>
            <Tooltip title={itemCountTooltip} placement="left-start">
              <Badge color="primary" badgeContent={item.ticketCount}>
                <Typography>{item.tktDisplayName}</Typography>
              </Badge>
            </Tooltip>
          </TableCell>
          <TableCell>{item.tktCategory}</TableCell>
          <TableCell>
            <Typography variant="body">{item.proDNI}</Typography>
          </TableCell>
          <TableCell>{Util.formatCurrency(item.tktPrice)}</TableCell>
          <TableCell>
            {Util.formatDateToShow(Util.timestampToMoment(item.tktInviteDate))}
          </TableCell>
          <TableCell
            style={
              isActive
                ? theme.table.activeCell
                : theme.overrides.MuiTableCell.body
            }
          >
            {stateLabel}
          </TableCell>
          <TableCell>
            <Tooltip title={item.createEmail}>
              <Typography variant="body">
                {item.createName} {item.createLastName}
              </Typography>
            </Tooltip>
          </TableCell>
          <TableCell style={{ ...theme.table.actionsColumn, minWith: 200 }}>
            {item.tktState == "pendingCreate" && (
              <div>
                <Tooltip title="Eliminar ticket por generar">
                  <IconButton onClick={this.onDeleteTicket.bind(this, item)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                {/* {item.tktState != "pendingCreate" && (
                  <Tooltip title="Transferir ticket">
                    <IconButton
                      onClick={this.onTransferTicket.bind(this, item)}
                    >
                      <ConfirmationNumberIcon />
                    </IconButton>
                  </Tooltip>
                )} */}
              </div>
            )}
          </TableCell>
        </TableRow>
      );
    });
  }

  render() {
    const { theme, open, invitationsList, handleSubmit, onClose } = this.props
    return (
      <Dialog open={open} maxWidth="lg">
        <DialogTitle>
          <Typography variant="h1" color="primary">Tickets a personas no registradas</Typography>
        </DialogTitle>
        <DialogContent style={{ minWidth: 500 }}>
          {/* <Box style={{ display: "flex", alignItems: "center" }}>
            <Typography style={theme.paper.title} variant="h2">
              Listado de Tickets a personas no registradas
            </Typography>
          </Box> */}
          <Toolbar style={{ ...theme.table.toolbar, justifyContent: "flex-end" }}>
            <Box>
              <TextField placeholder="Buscar" onChange={this.onSearch} />
              <IconButton onClick={this.onChangePage}>
                <SearchIcon style={{ fontSize: 20 }} />
              </IconButton>
            </Box>
          </Toolbar>
          <Table stickyHeader>
            <TableHead>{this.renderTableHeader()}</TableHead>
            <TableBody>{this.renderTableBody()}</TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={invitationsList.size}
            rowsPerPage={this.state.rowPerPage}
            page={this.state.page}
            onChangePage={this.onChangePage}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
          />
          <Dialog open={this.state.ticketForDelete}>
            <DialogTitle>Eliminar Ticket</DialogTitle>
            <DialogContent>
              <DialogContentText>
                ¿Está seguro que desea eliminar el ticket?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Tooltip title="Cancelar">
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    this.setState({ ticketForDelete: null });
                  }}
                >
                  Cancelar
                </Button>
              </Tooltip>
              <Tooltip title="Eliminar ticket">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onConfirmDeleteTicket}
                >
                  Eliminar
                </Button>
              </Tooltip>
            </DialogActions>
          </Dialog>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cerrar">
            <Button
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              Cerrar
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    )
  }
}

function mapStateToProps(store) {
  return {
    login: store.auth.login,
    invitationsList: store.evt.invitationsList,
    event: store.evt.event
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetInvitatios,
      actionDeleteTicket
    },
    dispatch
  );
}

export default reduxForm({
  form: "assignRolToUser",
  onSubmitFail: errors => _handleSubmitFail(errors)
})(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(InvitationsDialog)
  )
)


// WEBPACK FOOTER //
// ./src/screens/events/InvitationsDialog.js